import { faGear } from '@fortawesome/pro-regular-svg-icons';
import { StyledCardHeaderContainer, StyledHeaderTitle, StyledIcon, StyledSettingCard } from './setting-card.styles';
import { SettingCardProps } from './setting-card.types';
export const SettingCard = ({
  children,
  icon,
  title,
  showDefaultHeading = true
}: SettingCardProps) => <StyledSettingCard data-sentry-element="StyledSettingCard" data-sentry-component="SettingCard" data-sentry-source-file="setting-card.tsx">
    {showDefaultHeading && <StyledCardHeaderContainer>
        <StyledIcon data-testid="setting-card-icon" icon={icon ?? faGear} />
        <StyledHeaderTitle>{title ?? 'General'}</StyledHeaderTitle>
      </StyledCardHeaderContainer>}

    {children}
  </StyledSettingCard>;